import { useCartQuantity } from '@ecomm/shared-hooks'
import type { HeaderProps } from './types'

import { CourtesyNav } from './CourtesyNav'
import { LogoLink } from './LogoLink'
import { cartItem, phoneItem } from './data'

export function SlimHeader({
  type = 'full',
  slimMenuText = '',
  slimMenuURL = '',
  images,
  quoteWizard
}: HeaderProps) {
  const { cartQuantity } = useCartQuantity()
  return (
    <header className="bg-neutral-black relative w-full text-white lg:z-20">
      <nav className="py-p-4 max-w-8xl mx-auto flex h-[50px] items-center gap-4 px-3 max-[1125px]:justify-between md:gap-8 md:px-8 md:py-0 min-[1126px]:h-[78px]">
        <LogoLink type={type} />
        {type === 'slim' && (
          <>
            <div className="hidden flex-grow justify-end min-[1126px]:flex ">
              <div className="mr-4">{slimMenuText}</div>
            </div>
            <CourtesyNav
              cartQuantity={cartQuantity}
              images={images}
              items={[{ ...phoneItem, url: slimMenuURL }, cartItem]}
              quoteWizard={{ ...quoteWizard }}
            />
          </>
        )}
      </nav>
    </header>
  )
}
